import React, { Fragment, Component } from "react";
import { CSSTransition } from "react-transition-group";
import { detect } from "detect-browser";
import PortalHeader from "../shared/general/PortalHeader";
import InternetExplorerSupport from "../shared/general/InternetExplorerSupport";
import FormStep from "./FormSteps/FormStep";
import { Wrapper, Container } from "./styles/portal-agency-sign-up-styles";

interface State {
  ieMessageActive: boolean;
}

export class PortalAgencySignUp extends Component<unknown, State> {
  state = {
    ieMessageActive: detect().name === "ie",
  };

  closeIeMessage = (): void => {
    this.setState({ ieMessageActive: false });
  };

  render(): React.ReactNode {
    const { ieMessageActive } = this.state;

    return (
      <Fragment>
        {ieMessageActive && (
          <InternetExplorerSupport
            closeIeMessage={this.closeIeMessage}
            top="0"
          />
        )}
        <PortalHeader />
        <Wrapper>
          <Container>
            <CSSTransition
              in
              appear
              timeout={600}
              classNames="fade"
              unmountOnExit
            >
              <FormStep />
            </CSSTransition>
          </Container>
        </Wrapper>
      </Fragment>
    );
  }
}

export default PortalAgencySignUp;
